$(function() {
    var $drawerChk = $('#drawerCheckbox');
    var $body = $('body');
    var $header = $('.header');
    var $headerH = $header.outerHeight();
    var $main = $('.main');
    var $gNav = $header.find('.navColumns');
    var $gNavOv = $header.find('.gnavToggle__overlay');

    /* -------------------------------------------------------------
     スクロール時処理
     ------------------------------------------------------------- */
    if($(window).scrollTop() > $headerH) {
        $header.addClass("isFixed");
    }
    $(window).scroll(function () {
        if($(this).scrollTop() > $headerH) {
            $header.addClass("isFixed");
        } else {
            $header.removeClass("isFixed");
        };
    });
    /* -------------------------------------------------------------
     モバイル端末に切り替わった時の処理
     ------------------------------------------------------------- */
    var switchingToMobile = function() {
        $headerH = $header.outerHeight();
        $header.css({'position':'fixed'});
        $main.css({'margin-top':$headerH});
        $gNav.css({'padding-top':$headerH});
        $gNavOv.css({'top':$headerH});
        $drawerChk.prop('checked',false);
    };
    /* -------------------------------------------------------------
     PCに切り替わった時の処理
     ------------------------------------------------------------- */
    var switchingToPC = function() {
        $gNav.css({'padding-top':0});
        $header.css({'position':'fixed'});
        $drawerChk.prop('checked',false);
        $headerH = $header.outerHeight();
        $main.css({'margin-top':$headerH});
    };
    rwd.init();
    if (rwd.supported) {
        rwd.register('(min-width: 0) and (max-width: 979px)', switchingToMobile);
        rwd.register('(min-width: 980px)', switchingToPC);
        rwd.update();
        $('.pageContents .table__rwd').responsiveTable({
            secondlyClassName: 'table__rwd--mobile'
        });
    } else {
        switchingToPC();
    }
    $(document).on("click", ".gsc-cursor-page", function(){
        $("html,body").animate({scrollTop:$('.pageContents').offset().top},"fast");
    });
    $(document).on("click", ".gsc-cursor-container-previous", function(){
        $("html,body").animate({scrollTop:$('.pageContents').offset().top},"fast");
    });
    $(document).on("click", ".gsc-cursor-container-next", function(){
        $("html,body").animate({scrollTop:$('.pageContents').offset().top},"fast");
    });
});